const contactTypes = {
  GET_CONTACTS: "GET_CONTACTS",
  GET_CONTACTS_SUCCESS: "GET_CONTACTS_SUCCESS",
  GET_CONTACTS_FAILED: "GET_CONTACTS_FAILED",
  CREATE_CONTACTS: "CREATE_CONTACTS",
  CREATE_CONTACTS_SUCCESS: "CREATE_CONTACTS_SUCCESS",
  CREATE_CONTACTS_FAILED: "CREATE_CONTACTS_FAILED",
  UPDATE_CONTACT: "UPDATE_CONTACT",
  UPDATE_CONTACT_SUCCESS: "UPDATE_CONTACT_SUCCESS",
  UPDATE_CONTACT_FAILED: "UPDATE_CONTACT_FAILED",
  UPDATE_CONTACT_DATA: "UPDATE_CONTACT_DATA",
  UPDATE_CONTACT_DATA_SUCCESS: "UPDATE_CONTACT_DATA_SUCCESS",
  UPDATE_CONTACT_DATA_FAILED: "UPDATE_CONTACT_DATA_FAILED",
  DELETE_CONTACTS: "DELETE_CONTACTS",
  DELETE_CONTACTS_SUCCESS: "DELETE_CONTACTS_SUCCESS",
  DELETE_CONTACTS_FAILED: "DELETE_CONTACTS_FAILED",
  GET_CONTACT_ID: "GET_CONTACT_ID",
  GET_CONTACT_ID_SUCCESS: "GET_CONTACT_ID_SUCCESS",
  GET_CONTACT_ID_FAILED: "GET_CONTACT_ID_FAILED",
  GET_CONTACT_RUT: "GET_CONTACT_RUT",
  GET_CONTACT_RUT_SUCCESS: "GET_CONTACT_RUT_SUCCESS",
  GET_CONTACT_RUT_FAILED: "GET_CONTACT_RUT_FAILED",
  GET_CONTACT_DATA: "GET_CONTACT_DATA",
  GET_CONTACT_DATA_SUCCESS: "GET_CONTACT_DATA_SUCCESS",
  GET_CONTACT_DATA_FAILED: "GET_CONTACT_DATA_FAILED",
  // GET_CONTACT_ID_SUCCESS_EMPTY : "GET_CONTACT_ID_SUCCESS_EMPTY",
  GET_CONTRACT_BY_RUT: "GET_CONTRACT_BY_RUT",
  GET_CONTRACT_BY_RUT_SUCCESS: "GET_CONTRACT_BY_RUT_SUCCESS",
  GET_CONTRACT_BY_RUT_FAILED: "GET_CONTRACT_BY_RUT_FAILED",
  GENERATE_PASS: 'POST_GENERATED_PASS',
  GENERATE_PASS_SUCCESS: 'POST_GENERATED_PASS_SUCCESS',
  GENERATE_PASS_FAILED: 'POST_GENERATED_PASS_FAILED',
  RESET_CONTACT_STATE: "RESET_CONTACT_STATE",
  RESET_CONTACT_DATA: "RESET_CONTACT_DATA",
  RESET_CONTACT: "RESET_CONTACT",
}

export { contactTypes };